import { CartPromotionInvalidEnum, LanguageEnum } from 'enums'
import { CustomerAdjustmentInvalidDataType } from 'types'
import { t } from 'i18next'
import {
  AdjustmentInvalidReasonEnumType,
  AdjustmentTypeEnumType,
  OrderInvalidEnum,
} from 'graphQL/dinein/generate/operations'

export function getPromotionInvalidMsg(promotionInvalids: CartPromotionInvalidEnum[], lang: LanguageEnum): string {
  // PromoCode: InvalidDeliveryDateTime
  if (promotionInvalids.indexOf(CartPromotionInvalidEnum.InvalidConditions) !== -1) {
    return t('promoCodeInvalidCondition')
  }

  // PromoCode: InvalidPromotion
  if (promotionInvalids.indexOf(CartPromotionInvalidEnum.Duplicate) !== -1) {
    return t('promoCodeInvalidDuplicate')
  }

  // PromoCode: InvalidShippingAddress
  if (promotionInvalids.indexOf(CartPromotionInvalidEnum.NotExistedOrExpired) !== -1) {
    return t('promoCodeInvalidExsitedOrExpired')
  }

  // PromoCode: InvalidShippingAddress
  if (promotionInvalids.indexOf(CartPromotionInvalidEnum.Used) !== -1) {
    return t('promoCodeInvalidUsed')
  }

  return ''
}

export enum invalidDataEnum {
  minimumSatangs = 'minimumSatangs',
  remainingMinimumSatangs = 'remainingMinimumSatangs',
}

export const getInvalidDatas = (invalidData?: CustomerAdjustmentInvalidDataType): invalidDataEnum[] => {
  const invalids: invalidDataEnum[] = []

  if (invalidData) {
    invalidData?.minimumSatangs && invalids.push(invalidDataEnum.minimumSatangs)
    invalidData?.remainingMinimumSatangs && invalids.push(invalidDataEnum.remainingMinimumSatangs)
  }

  return invalids
}

export interface AdjustmentType {
  adjustmentType: AdjustmentTypeEnumType
  invalidReason: AdjustmentInvalidReasonEnumType
}

export const validateAdjusments = (adjustments?: AdjustmentType[]) => {
  let validate = true
  if (adjustments && Array.isArray(adjustments)) {
    const hasInsufficientTotalDue = adjustments.some(
      (adjustment) =>
        adjustment.adjustmentType === AdjustmentTypeEnumType.Cash &&
        adjustment.invalidReason === AdjustmentInvalidReasonEnumType.InsufficientTotalDue
    )
    if (hasInsufficientTotalDue) {
      validate = false
    }
  }
  return validate
}

export const handleCheckInvalidPromotion = (orderInvalids: OrderInvalidEnum[]) => {
  const orderInvalidPromotions = [
    OrderInvalidEnum.InvalidPromotion,
    OrderInvalidEnum.InvalidExternalCoupon,
    OrderInvalidEnum.InvalidMemberCoupon,
  ]
  return orderInvalidPromotions.some((invalidType) => orderInvalids.includes(invalidType))
}
